import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { ConfigurationService } from './app/Configuration/configuration.service';
import { Routes } from '@angular/router';
import { LoginComponent } from './app/components/auth/Pages/login/login.component';
import { AuthGuard } from './app/core/guards/auth.guard';


const configurationFactory = (configurationService: ConfigurationService) => {
  debugger
  return () => configurationService.loadConfiguration();
};


const routes: Routes = [

]

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
